import { createAction, createPayloadAction } from '../../../core/helpers'

import {
  ADD_AWARD,
  EXPAND_AWARD_MAIN_TREE_KEYS,
  EXPAND_AWARD_SUPPORTING_TREE_KEYS,
  FETCH_AWARDS,
  MOVE_AWARDS,
  RENAME_AWARD,
  RESET_AWARD_TREE,
  SET_DATA_FOR_RENAMING_AWARD,
} from '../action-types'

export const cleanupFetchAwards = createAction(FETCH_AWARDS.CLEANUP)

export const addAwardNode = createPayloadAction(ADD_AWARD)

export const renameAwardNode = createPayloadAction(RENAME_AWARD)
export const resetAwardTree = createAction(RESET_AWARD_TREE)
export const moveAwards = createPayloadAction(MOVE_AWARDS)

export const setDataForRenamingAward = createPayloadAction(
  SET_DATA_FOR_RENAMING_AWARD,
)

export const expandAwardMainTreeKeys = createPayloadAction(
  EXPAND_AWARD_MAIN_TREE_KEYS,
)

export const expandAwardSupportingTreeKeys = createPayloadAction(
  EXPAND_AWARD_SUPPORTING_TREE_KEYS,
)
